export interface TileSource {
  url: string;
  attribution: string;
  attributionUrl?: string;
  maxZoom: number;
  maxNativeZoom?: number;
  imagery: boolean;
}

export const OSM_STANDARD: TileSource = {
  url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: "© OpenStreetMap contributors",
  attributionUrl: "https://www.openstreetmap.org/copyright",
  maxZoom: 19,
  imagery: false,
};

export const ESRI_IMAGERY: TileSource = {
  url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  attribution: "Esri, Vantor, Earthstar Geographics, and the GIS User Community",
  maxZoom: 19,
  imagery: true,
};

const VWORLD_ATTRIBUTION = "국토지리정보원 VWorld";

export const vworldBase = (key: string): TileSource => ({
  url: `https://api.vworld.kr/req/wmts/1.0.0/${key}/Base/{z}/{y}/{x}.png`,
  attribution: VWORLD_ATTRIBUTION,
  maxZoom: 19,
  imagery: false,
});

export const vworldSatellite = (key: string): TileSource => ({
  url: `https://api.vworld.kr/req/wmts/1.0.0/${key}/Satellite/{z}/{y}/{x}.jpeg`,
  attribution: VWORLD_ATTRIBUTION,
  maxZoom: 19,
  imagery: true,
});

export function attributionHtml(source: TileSource): string {
  return source.attributionUrl
    ? `<a href="${source.attributionUrl}" target="_blank" rel="noreferrer">${source.attribution}</a>`
    : source.attribution;
}
